module.exports = __webpack_public_path__ + "static/fonts/Acumin-ItPro.acee2e5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Acumin-ItPro.woff
// module id = NUh2
// module chunks = 1